import builder from '../builder';
import House2 from '../../streamline-icons/bold/house-2.svg';

export default builder('IconHouse2Bold', House2);
